import React from 'react';

import { useExportTemplate, useStatusTemplates } from 'Templates';

import {
  Action,
  Actions,
  ActionBar,
  DescriptionIcon,
  FileDownloadIcon,
  FileUploadIcon,
} from '@gogame/components';
import { useChildComponent, useChooseFiles } from '@gogame/hooks-ts';
import { useScreenState, useScreenTitle } from '@gogame/screens';

import { MainBudgetPlanningFormCreate } from 'scenes/MainBudgetPlanning/components/MainBudgetPlanningForm';
import { TEMPLATE_NEW_MAIN_BUDGET_PLANNING } from 'scenes/MainBudgetPlanning/constants';
import {
  useExportMainBudgetPlanning,
  useImportMainBudgetPlanning,
} from 'scenes/MainBudgetPlanning/data';

export default () => {
  const [title] = useScreenTitle();
  const [childComponent, openChildComponent] = useChildComponent();

  const screenState = useScreenState();
  const {
    tableSettings: { orderBy, orderDir },
  } = screenState;

  const [exportMainBudgetPlanning] = useExportMainBudgetPlanning();
  const [importMainBudgetPlanning] = useImportMainBudgetPlanning();

  const handleCreate = () => {
    openChildComponent(MainBudgetPlanningFormCreate);
  };

  const templateUpdated = useStatusTemplates({
    name: TEMPLATE_NEW_MAIN_BUDGET_PLANNING,
  });

  const [exportTemplate] = useExportTemplate({
    name: TEMPLATE_NEW_MAIN_BUDGET_PLANNING,
  });

  const handleExportTemplate = async () => await exportTemplate();

  const handleExportMainBudgetPlanning = async () => {
    await exportMainBudgetPlanning({ orderBy, orderDir });
  };

  const chooseFiles = useChooseFiles({ accept: '.csv' });

  const handleImportMainBudgetPlanning = async () => {
    const [file] = await chooseFiles();
    await importMainBudgetPlanning(file);
  };

  return (
    <>
      <ActionBar
        title={title}
        primaryActions={
          <Actions>
            <Action
              icon={<FileDownloadIcon />}
              tooltip={'Export Plan'}
              onClick={handleExportMainBudgetPlanning}
            />
            <Action
              icon={<FileUploadIcon />}
              tooltip={'Import Plan'}
              onClick={handleImportMainBudgetPlanning}
            />
            <Action
              label={`Download Template${templateUpdated ? ' (Updated)' : ''}`}
              icon={<DescriptionIcon />}
              badge={templateUpdated}
              onClick={handleExportTemplate}
            />
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Period'}
              variant={'outlined'}
              onClick={handleCreate}
            />
          </Actions>
        }
      />
      {childComponent}
    </>
  );
};
